<template>
  <q-card>
    <q-card-section>
      <div class="row q-col-gutter-xs">
        <q-inner-loading :showing="loading">
          <q-spinner-dots size="50px" color="primary"/>
        </q-inner-loading>
        <div class="col-4">
          <q-select
            outlined
            v-model="donation.payment_form_id"
            :rules="[value => !!value  || 'Campo obrigatório']"
            options-dense
            map-options
            :display-value="'Forma de pagamento'"
            :options="optionDonationType"
            option-value="id"
            option-label="name"
            emit-value
            style="min-width: 150px"
          />
        </div>
        <div class="col-4">
          <q-input label="Valor" v-model="value"/>
        </div>
        <div class="col-4" v-if="donation.payment_form_id == 9">
          <q-input label="Número do cartão" v-model="card_number"/>
        </div>
        <div class="col-4" v-if="donation.payment_form_id == 9">
          <q-input label="Vencimento do cartão" placeholder="MM/AAAA" v-model="card_maturity" mask="##/####"/>
        </div>

        <div class="col-4" v-if="donation.payment_form_id > 9 || donation.payment_form_id == 1">
          <!-- <q-input label="Data" v-model="data" mask="##/##/####"/>-->
          <q-input filled :value="formattedDate" reverse-fill-mask :rules="['date']">
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date :options="options" v-model="data" @input="() => $refs.qDateProxy.hide()"/>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-4">
          <!-- <q-input label="Data" v-model="data" mask="##/##/####"/>-->
          <q-select

            label="Campanha"
            :options="campangns"
            map-options
            emit-value
            v-model="donation.campangn_id"
            option-value="id"
            option-label="name"
          />
        </div>
        <div class="col-4" v-if="donation.payment_form_id != ''">
          <q-btn v-if="donation.payment_form_id == 1" label="Gerar novo boleto" @click="addDonation"></q-btn>
          <q-btn v-if="donation.payment_form_id == 11" label="Gerar novo débito" @click="addDonation"></q-btn>
          <q-btn v-if="donation.payment_form_id == 9" label="Gerar novo crédito (Em homologação - sem efeito real)" @click="addDonation"></q-btn>
          <q-btn v-if="donation.payment_form_id > 11" label="Gerar doação" @click="addDonation"></q-btn>
        </div>
        <div class="col-4">
          <q-btn v-if="url !=''" type="a" :href="url" target="__blank" label="Baixar novo boleto"></q-btn>
        </div>
      </div>
      <q-dialog v-model="alert">
        <q-card style="width: 300px">
          <q-card-section>
            <div class="text-h6">Alerta</div>
          </q-card-section>

          <q-card-section>
            {{message}}
          </q-card-section>

          <q-card-actions align="right">
            <q-btn flat label="OK" color="primary" @click="alert = false"/>
          </q-card-actions>
        </q-card>
      </q-dialog>
    </q-card-section>

  </q-card>
</template>

<script>
import { CAMPANGNS_ALL, NEW_DONATION } from '../graphql/graphql'
import lang from 'quasar/lang/pt-br'
import { date as calendar } from 'quasar'

export default {
  name: 'NewDonation',
  props: {
    donator: Object
  },
  data () {
    return {
      value: 0,
      data: '',
      loading: false,
      alert: false,
      url: '',
      message: '',
      card_maturity: '',
      card_number: '',
      land: lang,
      newDonation: {},
      donation: {
        payment_form_id: 0,
        campangn_id: ''
      },
      optionDonationType: [
        { id: 1, name: 'Boleto' },
        { id: 11, name: 'Débito automático' },
        { id: 9, name: 'Cartão de crédito' },
        { id: 12, name: 'PayPal' },
        { id: 13, name: 'Transferência Identificada' },
        { id: 14, name: 'Transferência sem relacionamento' },
        { id: 15, name: 'Pólen' },
        { id: 16, name: 'Presente solidário' }
      ]
    }
  },
  apollo: {
    campangns: {
      query: CAMPANGNS_ALL
      // pollInterval: 300, // ms
    }
  },
  computed: {
    formattedDate () {
      return calendar.formatDate(this.data, 'DD/MM/YYYY')
    }
  },
  methods: {
    options (date) {
      if (this.donator.payment_form_id === 11) {
        let newDate = new Date()
        newDate = calendar.addToDate(newDate, { days: 7 })
        newDate = calendar.formatDate(newDate, 'YYYY-MM-DD')
        return date > calendar.formatDate(newDate, 'YYYY-MM-DD').split('-').join('/')
      } else {
        return true
      }
    },
    addDonation () {
      if (this.donator.payment_form_id < 12) {
        if (this.donator.agency === null || this.donator.bank_account === null || this.donator.bank === null) {
          this.alert = true
          this.message = 'Favor, verificar os dados de débito do doador!'
        } else {
          this.loading = true
          this.$apollo.mutate({
            mutation: NEW_DONATION,
            variables: {
              donator: this.donator.id,
              payment_form_id: this.donation.payment_form_id,
              campangn_id: this.donation.campangn_id,
              value: this.value,
              vencimento: this.data,
              card_number: this.card_number,
              card_maturity: this.card_maturity
            },
            // pollInterval: 300,
            update: (store, data) => {
              this.loading = false
              if (this.donation.payment_form_id === 1) {
                this.url = data.data.newDonation[0]
              } else if (this.donation.payment_form_id === 11) {
                // eslint-disable-next-line no-unused-expressions
                this.alert = true
                this.message = 'Arquivo de débito enviado para lais.silva@cancer.org.br.'
              }
            }
          })
        }
      } else {
        this.loading = true
        this.$apollo.mutate({
          mutation: NEW_DONATION,
          variables: {
            donator: this.donator.id,
            payment_form_id: this.donation.payment_form_id,
            value: this.value,
            campangn_id: this.donation.campangn_id,
            vencimento: this.data,
            card_number: this.card_number,
            card_maturity: this.card_maturity
          },
          // pollInterval: 300,
          update: (store, data) => {
            this.loading = false
            this.$emit('newdonationok')
            if (this.donation.payment_form_id === 1) {
              this.url = data.data.newDonation[0]
            } else if (this.donation.payment_form_id === 11) {
              // eslint-disable-next-line no-unused-expressions
              this.alert = true
              this.message = 'Arquivo de débito enviado para lais.silva@cancer.org.br.'
            } else if (this.donation.payment_form_id >= 11) {
              if (data.data.newDonation[0] === 'OK') {
                this.alert = true
                this.message = 'Doação registrada!'
              }
            } else if (this.donation.payment_form_id == 9) {
              this.alert = true
              this.message = data.data.newDonation[0]
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
